// extracted by mini-css-extract-plugin
module.exports = {"semiBold":"InspectionsTable_semiBold__1OvFU","semiBoldCenter":"InspectionsTable_semiBoldCenter__KPAQe","bold":"InspectionsTable_bold__kYphW"};